import {
  DropDownQuestion,
  MultiSelectQuestion,
  NumericOpenEndQuestion,
  OpenEndQuestion,
  Question,
  QuestionType,
  RankingQuestion,
  SingleSelectQuestion,
  StarRatingQuestion,
} from "../../types/Question";
import { generateShell } from "./shell";
import toXmlType_SingleSelect from "../questions/singleselect/converter";
import toXmlType_MultiSelect from "../questions/multiselect/converter";
import toXmlType_Numeric from "../questions/numericopenend/converter";
import toXmlType_Ranking from "../questions/ranking/converter";
import toXmlType_StarRating from "../questions/starrating/converter";
import toXmlType_OpenEnd from "../questions/openend/converter";
import toXmlType_DropDown from "../questions/dropdown/converter";
import convert from "xml-js";

const options = { compact: true, ignoreComment: false, spaces: 4 };

// TODO
// FIX:
// state="testing"

// theme="frozen:company/HIA_138_Default"



function generateQuestionXmlType(question: Question) {
  switch (question.type) {
    case QuestionType.SingleSelect:
      return toXmlType_SingleSelect(question as SingleSelectQuestion);
    case QuestionType.MultiSelect:
      return toXmlType_MultiSelect(question as MultiSelectQuestion);
    case QuestionType.NumericOpenEnd:
      return toXmlType_Numeric(question as NumericOpenEndQuestion);
    case QuestionType.Ranking:
      return toXmlType_Ranking(question as RankingQuestion);
    case QuestionType.StarRating:
      return toXmlType_StarRating(question as StarRatingQuestion);
    case QuestionType.OpenEnd:
      return toXmlType_OpenEnd(question as OpenEndQuestion);
    case QuestionType.DropDown:
      return toXmlType_DropDown(question as DropDownQuestion);
          
    default: {
      console.error(`No converter for question type ${QuestionType[question.type]}`);
      return {
        _comment: `No converter for question type ${QuestionType[question.type]}`,
      };
    }
  }
}

export default function generateSurveyXml(questions: Question[]) {
  const shell = generateShell();
  const questionXmlTypes = questions.map((q) => generateQuestionXmlType(q));
  const questionXmls = questionXmlTypes.map((q) => convert.js2xml(q, options));
  return `
<?xml version="1.0" encoding="UTF-8"?>\r\n
<survey \r\n
    alt="Test Survey"\r\n
    autosaveKey="PID,ssID,uuid,session,hid"\r\n
    browserDupes=""\r\n
    builder:cname="surveys.harrisinsights.com"\r\n
    builder:wizardCompleted="1"\r\n
    builderCompatible="1"\r\n
    compat="138"\r\n
    delphi="1"\r\n
    displayOnError="all"\r\n
    encryptData="1"\r\n
    extraVariables="source,list,url,record,ipAddress,userAgent,decLang,test,showLabels,jumpTo"\r\n
    featurephoneNotAllowedMessage="\${res.noFeaturePhone}"\r\n
    fir="on"\r\n
    html:showNumber="0"\r\n
    mobile="compat"\r\n
    mobileDevices="smartphone,tablet,desktop"\r\n
    name="Survey"\r\n
    progressOnTop="0"\r\n
    remerged="20211214_16:14"\r\n
    secure="1"\r\n
    setup="term,decLang,quota,time"\r\n
    spssSimpleCheckbox="1"\r\n
    ss:disableBackButton="1"\r\n
    ss:enableNavigation="0"\r\n
    ss:hideProgressBar="0"\r\n
    ss:includeJS="/survey/selfserve/53c/jquery.hia.clickable.fix.js"\r\n
    ss:listDisplay="1"\r\n
    state="closed"\r\n
    theme="frozen:company/HIA_138_Default"\r\n
    version="5">\r\n
    ${shell}
    ${questionXmls.join("\r\n<suspend/>\r\n")}
</survey>
    `;
}
